<template>
    <div>
        <div>
            <img class="zgmh" src="~@public/img/hotApply/zgmh.jpg">
        </div>
        <p class="title">长按图片，识别民航临时乘机证明小程序</p>
    </div>
</template>

<script>
    export default {
        name: "RideCertificate"
    }
</script>

<style scoped>
    .zgmh {
        width: 75%;
        margin: 4.0rem 1.0rem 1.0rem 1.2rem
    }
    .title{
        font-size: 0.5rem;
        text-align: center;
        color:black;
    }
</style>